module.exports = __webpack_public_path__ + "static/media/playback-category-cycle.7b7ee880.png";